import request from '@/utils/request'


// 查询球场列表
export function listPitch(query) {
  return request({
    url: '/golf/golf-pitch/list',
    method: 'get',
    params: query
  })
}

// 查询球场分页
export function pagePitch(query) {
  return request({
    url: '/golf/golf-pitch/page',
    method: 'get',
    params: query
  })
}

// 查询球场详细
export function getPitch(data) {
  return request({
    url: '/golf/golf-pitch/detail',
    method: 'get',
    params: data
  })
}

// 新增球场
export function addPitch(data) {
  return request({
    url: '/golf/golf-pitch/add',
    method: 'post',
    data: data
  })
}

// 修改球场
export function updatePitch(data) {
  return request({
    url: '/golf/golf-pitch/edit',
    method: 'post',
    data: data
  })
}

// 删除球场
export function delPitch(data) {
  return request({
    url: '/golf/golf-pitch/delete',
    method: 'post',
    data: data
  })
}
